import React, { useEffect } from 'react';
import ProfilePageContainer from 'shared/profile/ProfilePageContainer';
import ProfilePageSectionContainer from 'shared/profile/ProfilePageSectionContainer';
import ProjectsView from './components/ProjectsView';
import Project from './components/Project';
import PlaceholderCard from './components/ProjectsPagePlaceholderCard';
import paths from 'paths';
import PrimaryButton from 'shared/buttons/PrimaryButton';
import { useHistory } from 'react-router-dom';
import { ButtonColor, ButtonType } from 'shared/buttons/models/ButtonModels';

export default function ProjectsPage() {
  const history = useHistory();

  const switchToPackagesView = () => {
    history.push(paths.profilePackages + history.location.search);
  };
  return (
    <div className="bg-ev-light-yellow">
      <ProfilePageContainer
        title="My projects"
        header={
          <span className="flex">
            <span>Projects</span>
            <div className="ml-auto">
              <PrimaryButton
                text={'Switch to Packages'}
                onClick={switchToPackagesView}
                buttonColor={ButtonColor.White}
                buttonType={ButtonType.Action}
              />
            </div>
          </span>
        }
        description={
          <>
            The projects homepage lists all charts, maps, tables and layouts you have created. Insert a project into
            your Dina interface by clicking the copy button on the project card.
          </>
        }
      >
        <ProfilePageSectionContainer>
          <ProjectsView with={Project} placeholder={PlaceholderCard} deleted={false} />
        </ProfilePageSectionContainer>
      </ProfilePageContainer>
    </div>
  );
}
